import { useAuthStore } from "@/aygulyazilim/store/useAuth"
import { useHelpersStore } from "@/aygulyazilim/store/useHelpers"
import { getI18n } from '@/plugins/i18n/index.js'

export const setupGuards = router => {
  // 👉 router.beforeEach
  // Docs: https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards
  router.beforeEach(async to => {
    const authStore = useAuthStore()
    const store = useHelpersStore()
    const t = getI18n().global.t

    await store.fetchConfig()

    const title = to.meta?.title ? t(to.meta.title) : null

    document.title = title
      ? title + " | " + store.config.firma_adi
      : store.config.firma_adi

    /*
     * Check if user is trying to access auth pages that are disabled in settings
     */
    if (to.name === 'register' && !store.config.yeni_kullanici_kayit) {
      return { name: 'login' }
    }

    if (to.name === 'forgot-password' && !store.config.kullanici_sifremi_unuttum) {
      return { name: 'login' }
    }

    /*
     * If it's a public route, continue navigation. This kind of pages are allowed to visited by login & non-login users. Basically, without any restrictions.
     * Examples of public routes are, 404, under maintenance, etc.
     */
    if (to.meta.public) return
    
    // Fetch bootstrap data if user is not loaded yet, or ensure licenses are cached
    if (authStore.user.uuid.length === 0) {
      await authStore.bootstrap()
    } else if (store.licenses.length === 0) {
      await store.fetchLicenses()
    }

    if (authStore.user && authStore.user.force_password_change && to.name !== 'profil' && to.name !== 'login' && to.name !== 'logout' && to.name !== 'not-authorized') {
      return { name: 'profil' }
    }

    /**
     * Check if user is logged in by checking if token & user data exists in local storage
     * Feel free to update this logic to suit your needs
     */
    // const isLoggedIn = !!(useCookie('userData').value && useCookie('accessToken').value)

    /*
          If user is logged in and is trying to access login like page, redirect to home
          else allow visiting the page
          (WARN: Don't allow executing further by return statement because next code will check for permissions)
         */

    // eslint-disable-next-line sonarjs/no-collapsible-if
    if (to.matched.length) {
      const yetki = to.meta.yetki || {}
      
      // Extract module name from route name (e.g., 'personel-liste' -> 'Personel')
      let modulAdi = null
      if (to.name && store.allModules.length > 0) {
        const lowerName = to.name.toLowerCase()
        
        // Sort by length descending to match 'ProjeAlt' before 'Proje'
        const sortedModules = [...store.allModules].sort((a, b) => b.length - a.length)
        
        const found = sortedModules.find(m => {
          const kebabM = m.replace(/([a-z\d])([A-Z])/g, "$1-$2").toLowerCase()
          
          return lowerName === kebabM || lowerName.startsWith(kebabM + '-')
        })

        if (found) modulAdi = found
      }

      if (!store.yetkiKontrol({ ...yetki, m: modulAdi })) {
        return authStore.isLoggedIn
          ? { name: "not-authorized" }
          : { name: "login" }
      }
    }

    // if (to.meta.unauthenticatedOnly) {
    //   if (authStore.isLoggedIn)
    //     return '/'
    //   else
    //     return undefined
    // }

    // if (!canNavigate(to) && to.matched.length) {
    //   /* eslint-disable indent */
    //         return authStore.isLoggedIn
    //             ? { name: 'not-authorized' }
    //             : {
    //                 name: 'login',
    //                 query: {
    //                     ...to.query,
    //                     to: to.fullPath !== '/' ? to.path : undefined,
    //                 },
    //             }
    //         /* eslint-enable indent */
    // }
  })
}
